import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { colors, dimensions, radius, spacing } from '../../utils/styles';

const KitchenIndicatorRoot = styled(`div`)`
  background: ${colors.lemon};
  border-radius: ${radius.default}px;
  color: ${colors.brand};
  display: ${props => (props.visible ? 'flex' : 'none')};
  justify-content: center;
  left: 0;
  padding: ${spacing.xs}px ${spacing.sm}px;
  position: absolute;
  top: calc(${dimensions.headerHeight} + ${spacing.md}px);
  transform: translateX(calc((100% + ${spacing.md}px) * -1));
`;

class KitchenIndicator extends Component {
  state = {
    visible: false,
    message: ''
  };

  componentDidUpdate(prevProps) {
    if (prevProps.adding !== this.props.adding) {
      if (this.props.adding) {
        this.setState({
          visible: true,
          message: 'updating Kitchen ...'
        });
      } else {
        if (this.props.itemsInKitchen > prevProps.itemsInKitchen) {
          const num = this.props.itemsInKitchen - prevProps.itemsInKitchen;
          const message =
            num > 1
              ? `${num} new items have been added to the Kitchen`
              : `${num} new item has been added to the Kitchen`;

          this.setState({ message });

          setTimeout(
            () => this.setState({ visible: false, message: '' }),
            3000
          );
        }
      }
    }
  }

  render() {
    const { visible, message } = this.state;

    return <KitchenIndicatorRoot visible={visible}>{message}</KitchenIndicatorRoot>;
  }
}

KitchenIndicator.propTypes = {
  itemsInKitchen: PropTypes.number.isRequired,
  adding: PropTypes.bool.isRequired
};

export default KitchenIndicator;
